import { render, staticRenderFns } from "./VehicleFields.vue?vue&type=template&id=9aeb9b44&"
import script from "./VehicleFields.vue?vue&type=script&lang=ts&"
export * from "./VehicleFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports